"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageInfoServiceV1Impl = exports.PageInfoStore = void 0;
const EventEmitter_1 = require("./EventEmitter");
class PageInfoStore {
    constructor(getNavigationState, defaultPageInfo, logger, resetableSecondaries = []) {
        this.getNavigationState = getNavigationState;
        this.defaultPageInfo = defaultPageInfo;
        this.logger = logger;
        this.resetableSecondaries = resetableSecondaries;
        this.eventEmitter = new EventEmitter_1.EventEmitter();
    }
    getPageInfo() {
        if (this.isSecondary() && !!this.secondaryPageInfo) {
            const state = this.getNavigationState();
            const canonicalUrl = this.getCanonicalUrl(state);
            if (this.primaryPageInfo) {
                return {
                    logoCategory: this.secondaryPageInfo.logoCategory ||
                        this.primaryPageInfo.logoCategory,
                    seo: Object.assign(Object.assign(Object.assign({}, this.primaryPageInfo.seo), this.secondaryPageInfo.seo), { canonicalUrl }),
                    response: this.secondaryPageInfo.response,
                };
            }
            return this.secondaryPageInfo;
        }
        else if (this.primaryPageInfo) {
            return this.primaryPageInfo;
        }
        else {
            return this.defaultPageInfo;
        }
    }
    serialize() {
        return JSON.stringify({
            secondaryConsumerId: this.lastSecondaryConsumerId,
            secondaryPageInfo: this.secondaryPageInfo,
            primaryPageInfo: this.primaryPageInfo,
        });
    }
    deserialize(data) {
        if (!data) {
            return;
        }
        const { secondaryConsumerId, primaryPageInfo, secondaryPageInfo, } = JSON.parse(data);
        if (secondaryPageInfo) {
            this.secondaryPageInfo = secondaryPageInfo;
            this.lastSecondaryConsumerId = secondaryConsumerId;
        }
        if (primaryPageInfo) {
            this.primaryPageInfo = primaryPageInfo;
        }
    }
    getCanonicalUrl(state) {
        var _a, _b, _c, _d;
        if (state.subPage) {
            return (((_b = (_a = this.secondaryPageInfo) === null || _a === void 0 ? void 0 : _a.seo) === null || _b === void 0 ? void 0 : _b.canonicalUrl) || state.currentCanonicalUrl);
        }
        return ((_d = (_c = this.primaryPageInfo) === null || _c === void 0 ? void 0 : _c.seo) === null || _d === void 0 ? void 0 : _d.canonicalUrl) || state.currentCanonicalUrl;
    }
    getSource() {
        if (this.isSecondary()) {
            return 'secondary';
        }
        else if (this.primaryPageInfo) {
            return 'primary';
        }
        else {
            return 'default';
        }
    }
    setPageInfo(pageInfo, consumerId) {
        if (consumerId === this.getNavigationState().secondaryConsumerId) {
            this.logger.debug('setPageInfo for secondary consumer', !!pageInfo);
            this.secondaryPageInfo = pageInfo;
            this.lastSecondaryConsumerId = consumerId;
            this.eventEmitter.emit();
        }
        else if (consumerId === this.getNavigationState().primaryConsumerId) {
            this.logger.debug('setPageInfo for primary consumer', !!pageInfo);
            if (this.lastSecondaryConsumerId &&
                this.resetableSecondaries.includes(this.lastSecondaryConsumerId)) {
                this.logger.debug('reset secondary consumer', this.lastSecondaryConsumerId);
                // for mydealer we reset seconadry page info when primary is set
                this.lastSecondaryConsumerId = undefined;
            }
            this.primaryPageInfo = pageInfo;
            this.eventEmitter.emit();
        }
    }
    isSecondary() {
        return (!!this.secondaryPageInfo &&
            !!this.getNavigationState().secondaryConsumerId &&
            this.getNavigationState().secondaryConsumerId ==
                this.lastSecondaryConsumerId);
    }
    subscribe(consumerId, listener) {
        return this.eventEmitter.subscribe(consumerId, listener);
    }
    unsubscribeAll(consumerId) {
        this.eventEmitter.unsubscribeAll(consumerId);
    }
    getPrimaryInfo() {
        return this.primaryPageInfo || this.defaultPageInfo;
    }
}
exports.PageInfoStore = PageInfoStore;
class PageInfoServiceV1Impl {
    constructor(consumerId, store) {
        this.consumerId = consumerId;
        this.store = store;
    }
    setPageInfo(pageInfo) {
        this.store.setPageInfo(pageInfo, this.consumerId);
    }
    getPageInfo() {
        return this.store.getPageInfo();
    }
    subscribe(listener) {
        return this.store.subscribe(this.consumerId, listener);
    }
    getSource() {
        return this.store.getSource();
    }
    unbind() {
        return this.store.unsubscribeAll(this.consumerId);
    }
    getPrimaryInfo() {
        return this.store.getPrimaryInfo();
    }
}
exports.PageInfoServiceV1Impl = PageInfoServiceV1Impl;
//# sourceMappingURL=index.js.map